import React from 'react';
import { motion } from 'framer-motion';
import { APPOINTMENT_URL } from '../../config/credentials';
import './AppointmentButton.css';

const AppointmentButton = () => {
  return (
    <div className="appointment-button-container">
      <motion.a
        href={APPOINTMENT_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="appointment-button"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        <span className="button-icon">📅</span>
        Reserva tu 1ª cita con un Psicólogo
      </motion.a>
      
      <p className="appointment-note">
        Consulta de valoración inicial
      </p>
    </div>
  );
};

export default AppointmentButton;
